import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=7c6b776a&"
import script from "./OurStory.vue?vue&type=script&lang=js&"
export * from "./OurStory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports